import * as React from "react";
import type { SVGProps } from "react";
const SvgCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 186.26 186.26"
    {...props}
  >
    <path
      fillRule="nonzero"
      d="m26.33 8.47 66.8 66.8 66.8-66.8 17.86 17.86-66.8 66.8 66.8 66.8-17.86 17.86-66.8-66.8-66.8 66.8-17.86-17.86 66.8-66.8-66.8-66.8z"
      className="fil0"
    />
  </svg>
);
export default SvgCross;
